module.exports = __webpack_public_path__ + "fonts/museo-sans-500-webfont.a58f9e1.ttf";